<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>
<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ข้อมูลโรงกำจัด
      </div>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        elevation="0"
        large
        dark
        class="mr-4 px-10"
        @click="insert"
      >
        <div><v-icon left>mdi-plus</v-icon>เพิ่มข้อมูลโรงกำจัด</div>
      </v-btn>
    </v-layout>
    <v-divider class="mt-2 mb-8"></v-divider>
    <v-data-table
      dense
      :headers="headers"
      :items="getIndex"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <div class="text-center">
      <v-dialog v-model="dialog" persistent max-width="1000px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h4 font-weight-black primary--text text-spacing"
                >แก้ไขข้อมูลโรงกำจัด</span
              >
            </v-card-title>
            <v-card-text>
              <v-container>
                <div class="d-flex flex-column">
                  <div class="d-flex justify-start">
                    <div style="margin-left: 50px; width: 200px">
                      <div class="mt-3">
                        <h4>ชื่อโรงกำจัด :</h4>
                      </div>

                      <div class="mt-12" style="margin-bottom: 95px !important">
                        <h4>ที่อยู่ :</h4>
                      </div>
                      <div>
                        <h4>อีเมล์(โรงกำจัด) :</h4>
                      </div>
                    </div>
                    <div style="width: 300px">
                      <div>
                        <v-text-field
                          solo
                          label="ชื่อโรงกำจัด"
                          v-model="c_name"
                          :rules="nameRules"
                        ></v-text-field>
                      </div>

                      <div>
                        <v-textarea
                          solo
                          label="ที่อยู่"
                          rows="3"
                          no-resize
                          v-model="c_address"
                          :rules="nameRules"
                        ></v-textarea>
                      </div>
                      <div>
                        <v-text-field
                          solo
                          label="อีเมล์"
                          v-model="c_email"
                          :rules="nameRules"
                        ></v-text-field>
                      </div>
                    </div>
                    <div style="margin-left: 50px; width: 200px">
                      <div class="mt-3">
                        <h4>ชื่อพนักงาน :</h4>
                      </div>
                      <div class="mt-12">
                        <h4>เบอร์สำนักงาน :</h4>
                      </div>
                      <div class="mt-12">
                        <h4>เบอร์มือถือ :</h4>
                      </div>
                    </div>
                    <div style="width: 300px">
                      <div>
                        <v-text-field
                          solo
                          label="ชื่อพนักงาน"
                          v-model="c_preson"
                          :rules="nameRules"
                        ></v-text-field>
                      </div>
                      <div>
                        <v-text-field
                          solo
                          label="เบอร์สำนักงาน"
                          v-model="c_tel"
                          :rules="nameRules"
                        ></v-text-field>
                      </div>
                      <div>
                        <v-text-field
                          solo
                          label="เบอร์มือถือ"
                          v-model="c_mobile"
                          :rules="nameRules"
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                  <v-divider class="my-2"></v-divider>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                ยกเลิก
              </v-btn>
              <v-btn color="blue darken-1" text @click="save"> บันทึก </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    valid: true,
    dialog: false,
    desserts: [],
    headers: [
      {
        text: "ลำดับ",
        align: "start",
        sortable: false,
        value: "id",
      },
      {
        text: "ชื่อโรงกำจัด",
        align: "start",
        sortable: false,
        value: "DESTROYER_NAME",
      },
      { text: "ที่อยู่", value: "DESTROYER_ADDRESS", sortable: false },
      { text: "เบอร์สำนักงาน", value: "DESTROYER_PHONE", sortable: false },
      { text: "เบอร์มือถือ", value: "DESTROYER_OFFCIA_PHONE", sortable: false },
      { text: "e-mail", value: "DESTROYER_EMAIL", sortable: false },
      { text: "จัดการ", value: "actions", sortable: false },
    ],
    id: "",
    c_name: "",
    c_address: "",
    c_email: "",
    c_tel: "",
    c_mobile: "",
    c_preson: "",
    nameRules: [(v) => !!v || "กรุณากรอกให้ถูกต้อง"],

    emailRules: [
      (v) => !!v || "กรุณากรอก E-mail",
      (v) => /.+@.+\..+/.test(v) || "กรุณากรอก E-mail ให้ถูกต้อง",
    ],
  }),
  methods: {
    insert() {
      this.$router.push({ path: "/settings/company-insert-destroy" });
    },
    selectDestroy() {
      this.$token_api
        .get("/select-data-destroy")
        .then((res) => {
          this.desserts = res.data.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    editItem(item) {
      console.log(item);
      this.c_name = item.DESTROYER_NAME;
      this.c_address = item.DESTROYER_ADDRESS;
      this.c_email = item.DESTROYER_EMAIL;
      this.c_tel = item.DESTROYER_PHONE;
      this.c_mobile = item.DESTROYER_OFFCIA_PHONE;
      this.c_preson = item.DESTROYER_OFFCIA;
      this.id = item.DESTROYER_ID;
      this.dialog = true;
    },
    deleteItem(item) {
      console.log(item);

      this.$swal({
        title: "ลบข้อมูลรถ",
        text: `กรุณากดปุ่ม "ยีนยัน" เพื่อลบข้อมูล`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          //console.log(item.CAR_ID)
          //ยังลบไม่ได้ ติด FOREIGN KEY
          this.$token_api
            .post("/delete-data-destroy", item)
            .then((res) => {
              this.selectDestroy();
            })
            .catch((e) => {
              console.log(e);
            });
        }
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        let data_i = {
          DESTROYER_NAME: this.c_name,
          DESTROYER_ADDRESS: this.c_address,
          DESTROYER_PHONE: this.c_tel,
          DESTROYER_OFFCIA_PHONE: this.c_mobile,
          DESTROYER_EMAIL: this.c_email,
          DESTROYER_OFFCIA: this.c_preson,
          DESTROYER_ID: this.id,
        };
        // console.log(data_i);
        this.$token_api
          .post("/edit-data-destroy", data_i)
          .then((res) => {
            this.$swal({
              title: "แก้ไขเรียบร้อย",
              timer: 2000,
              icon: "success",
            });
            this.dialog = false;
            this.selectDestroy();
          })
          .catch((e) => {
            this.$swal({
              title: "เกิดข้อบกพร่อง",
              text: "กรุณากรอกลองใหม่อีกครั้ง",
              timer: 2000,
              icon: "success",
            });
            console.log(e);
          });
      } else {
        this.$swal({
          title: "ข้อมูลไม่ครบ",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          timer: 2000,
          icon: "warning",
        });
      }
    },
  },
  created() {
    this.selectDestroy();
  },
  computed: {
    getIndex() {
      return this.desserts.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
    },
  },
};
</script>